module.exports = __webpack_public_path__ + "assets/icon-trending-down-component.d01e6612.svg";